import { createStore } from 'store-utils';

const ConnectorConfigureFormStore = createStore<ConnectorConfigureFormState>(
  {
    token: '',
    name: '',
    password: '',
    hostURL: '',
    clientId: '',
    secretKey: '',
    awsRoleArn: '',
    awsExternalId: '',
    awsAccessKey: '',
    awsAccessSecret: '',
    tenant: '',
  },
  'Connector Configure Form',
);

interface ConnectorConfigureFormState {
  token: string;
  name: string;
  password: string;
  hostURL: string;
  clientId: string;
  secretKey: string;
  awsRoleArn: string;
  awsExternalId: string;
  awsAccessKey: string;
  awsAccessSecret: string;
  tenant: string;
}

export default ConnectorConfigureFormStore;
